<template>
  <div>
    <h2 style="margin-top: 80px;">
      Если Вы выбрали оплату путем перевода денежных средств на наш р/с, то просим проверить:
    </h2>


    <div style="background:#F9F9F9; margin:0 -10%; padding:10%;">




      <p style="color:#1526ff; font-weight:500;">
        <span class="legal-ul-number">1.</span>
        Правильно ли указаны данные для оплаты. Наши реквизиты:
      </p>
      <p>
        <span style="font-size:12px; opacity:0.5;" class="">Компания</span>
        <br>
        ООО "Джаст Резерв"
      </p>
      <p>
        <span style="font-size:12px; opacity:0.5;" class="">УНП</span>
        <br>
        192954057
      </p>
      <p>
        <span style="font-size:12px; opacity:0.5;" class="">Расчётный счёт (BYN)</span>
        <br>
        BY11 ALFA 3012 2259 6801 6027 0000
      </p>
      <p>
        <span style="font-size:12px; opacity:0.5;" class="">Банк</span>
        <br>
        ЗАО "Альфа-Банк", BIC ALFABY2X
        <br>
        <span style="font-size:12px; opacity:0.5;" class="">г. Минск, ул. Сурганова, 43-47</span>

      </p>


      <p class="ff-mrgn-t-60" style="color:#1526ff; font-weight:500;">
        <span class="legal-ul-number">2.</span>
        Содержит ли назначение платежа всю полноту информации:
      </p>

      <p>
        Наименование платежа (лицензионное вознаграждение), дата и номер документа, служащего основанием для осуществления платежа (номер и дата договора между Нашей организацией и Вами, номер и дата счета на оплату/иного документа на оплату), иная информация о платеже (за какой период производится оплата).
      </p>

    </div>

    <h2 style="margin-top: 60px;">
      Обращаем внимание:
    </h2>

    <p>
      Банк-отправитель и банк-получатель обязаны исполнить платежное поручение в случае его акцепта в тот банковский день, когда это поручение получено. При недостаточности времени для исполнения платежного поручения до окончания банковского дня оно может быть исполнено в следующий за ним банковский день. В платежном поручении может быть указан иной срок его исполнения (ст. 248 Банковсакого кодекса Республики Беларусь).
    </p>

    <p>
      Обязательства Клиента по уплате вознаграждения считаются исполненным с даты поступления денежных средств на расчетный счет Компании в объеме, соответствующем Тарифному плану (тарифам) и условиям настоящего Договора (п. 5.14. Лицензионного договора).
    </p>
  </div>
</template>

<script>
export default {
  name: 'TransferToRSDescription'
}
</script>
